import type { WorkActionPresentation } from '@shared/types/work-action';

/**
 * Values already established by the Account Thread. This mapping stays
 * deliberately closed: an absent contact, domain or criterion remains absent.
 */
export const buildContextualToolPrefill = (
  toolKey: string,
  work: Pick<WorkActionPresentation, 'context'>,
): Record<string, string> => {
  const account = (
    work.context.decisionFocus?.accountSubjectId
      ? work.context.decisionFocus.accountLabel
      : work.context.subjectKind === 'company'
        ? work.context.subjectLabel
        : ''
  ).trim();
  if (!account) return {};

  if (toolKey === 'qualify_account' || toolKey === 'prepare_meeting') {
    return { company_name: account };
  }

  return {};
};
